<template>
  <v-container>
    <v-row class="text-center" align="center">
      <v-card
      class="mx-auto my-6" width="90%" elevation="2" outlined
            :color="'#1F7087'"
            dark
            @click="$emit('click')"
          >
            <div class="d-flex flex-no-wrap justify-space-between">
              <v-avatar
                class="ma-3"
                size="125"
                tile
              >
                <v-img :src="imageUrl"></v-img>
              </v-avatar>


              <div>
                <v-card-title
                  class="headline"
                  v-text="title"
                ></v-card-title>

                <v-card-subtitle v-text="desc"></v-card-subtitle>

                <!-- <v-card-actions>
                  <v-btn
                    class="ml-2 mt-5"
                    outlined
                    rounded
                    small
                  >
                    換一本
                  </v-btn>
                </v-card-actions> -->
              </div>

              
            </div>
          </v-card>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'BookCard',
    props: ['title', 'imageUrl', 'desc'],
    data() {
        return {
        }
    },
    
  }
</script>
